@if (show()) {
  <div class="overlay-loader">
    <div class="row">
      <div class="col-4 offset-4">
        <div class="lds-css">
          <div class="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
